export const HOME_PAGE = '首页';
